import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
  // Scroll to top when page opens
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-page container">
      <div className="policy-container ice-card">
        <h1>Privacy Policy</h1>
        <p className="policy-date">Last Updated: April 16, 2026</p>

        <section>
          <h3>1. Information We Collect</h3>
          <p>We collect basic information when you register, including the student's name, parent's mobile number, and preferred academic track.</p>
        </section>

        <section>
          <h3>2. How We Use Your Data</h3>
          <p>The data is used solely to contact you regarding enrollment and curriculum details for the Narayana Summer Camp 2026.</p>
        </section>

        <section>
          <h3>3. Data Sharing</h3>
          <p>Vulli Narayana Tuitions does not sell or share your personal information with third parties. Your data is strictly for internal use.</p>
        </section>

        <section>
          <h3>4. Contact Us</h3>
          <p>For any queries regarding your data, please contact us at 9700213084.</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;